const state = {};

const getters = {
  getUserRole(state, getters) {
    const currentStore = getters.getSelectedStore;

    if (!currentStore) return "";

    return currentStore.profile;
  },
  getPermissions(state, getters) {
    const currentStore = getters.getSelectedStore;

    if (!currentStore) return computedRules();

    const rules = computedRules(currentStore.rules);
    return rules;
  }
};
const mutations = {};
const actions = {
  cleanRules({ commit, dispatch }) {
    dispatch("setStores", null);
    commit("setSelectedStore", null);
  }
};

function computedRules(rules) {
  const permissions = [
    {
      title: "Início",
      icon: "home",
      route: "/home",
      rules_actions: null,
      disabled: false,
      readOnly: false
    },
    {
      title: "Insights",
      icon: "equalizer",
      route: "/insights",
      rules_name: "insights",
      rules_actions: null,
      disabled: true,
      readOnly: true
    },
    {
      title: "Pedidos",
      icon: "attach_money",
      route: "/sales",
      rules_name: "sales",
      rules_actions: null,
      disabled: true,
      readOnly: true
    },
    {
      title: "Carteira",
      icon: "account_balance_wallet",
      route: "/wallet",
      rules_name: "wallet",
      rules_actions: null,
      disabled: true,
      readOnly: true
    },
    {
      title: "Colaboradores",
      icon: "group",
      route: "/employees",
      rules_name: "employees",
      rules_actions: null,
      disabled: true,
      readOnly: true
    },
    {
      title: "Entrega",
      icon: "local_shipping",
      route: "/delivery",
      rules_name: "delivery",
      rules_actions: null,
      disabled: true,
      readOnly: true
    }
  ];

  if (!rules) return permissions;

  return permissions
    .map((item) => {
      if (item.rules_name && rules[item.rules_name]) {
        const { write, read } = rules[item.rules_name];
        return {
          ...item,
          disabled: !read,
          readOnly: !write
        };
      }
      return item;
    })
    .filter((item) => !item.disabled);
}

export default {
  state,
  getters,
  mutations,
  actions
};
